/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/250-hipster': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM4 5a1 1 0 112 0 1 1 0 01-2 0zm6 0a1 1 0 112 0 1 1 0 01-2 0z"/><path pid="1" d="M10.561 8.439a1.5 1.5 0 10-2.063 2.176c1.352 1.227 4.503-.029 4.503-1.615-.969.625-1.726.153-2.439-.561z"/><path pid="2" d="M5.439 8.439a1.5 1.5 0 112.063 2.176C6.15 11.842 2.999 10.586 2.999 9c.969.625 1.726.153 2.439-.561z"/>'
  }
})
